import { t } from '@lingui/macro'
import { TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'

export interface CioxRequestData {
    providerName: string
}

interface CioxRequestInputProps {
    onSubmit: (data: CioxRequestData) => void
    onCancel: () => void
    isLoading?: boolean
    error?: string | null
    initialValue?: string
    isEditMode?: boolean
}

export const CioxRequestInput: React.FC<CioxRequestInputProps> = ({
    onSubmit,
    onCancel,
    isLoading = false,
    error: propError = null,
    initialValue = '',
    isEditMode = false
}) => {
    const [providerName, setProviderName] = useState(initialValue)
    const [error, setError] = useState<string | null>(propError)

    useEffect(() => {
        setProviderName(initialValue)
    }, [initialValue])

    useEffect(() => {
        setError(propError)
    }, [propError])

    const handleSubmit = () => {
        if (!providerName.trim()) {
            setError(t`Provider name is required`)
            return
        }

        onSubmit({
            providerName: providerName.trim()
        })
    }

    return (
        <div className='w-full'>
            <h2 className='text-xl font-semibold mb-4'>{isEditMode ? t`Edit Ciox Request` : t`Add Ciox Request`}</h2>
            <p className='text-sm text-gray-600 mb-6'>{t`Enter the provider name for the ciox request`}</p>

            {error && <div className='mb-4 p-3 bg-red-50 text-red-600 rounded-md border border-red-200'>{error}</div>}

            <div className='space-y-6'>
                <TextField
                    fullWidth
                    label={t`Provider Name`}
                    name='provider_name'
                    value={providerName}
                    onChange={(e) => {
                        setProviderName(e.target.value)
                        setError(null)
                    }}
                    data-testid='provider-name-input'
                    variant='outlined'
                    placeholder={t`Enter provider name`}
                    size='medium'
                />

                <div className='flex justify-end space-x-3 pt-4'>
                    <button
                        onClick={onCancel}
                        className='px-6 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2'
                        aria-label={t`Cancel`}
                    >
                        {t`Cancel`}
                    </button>
                    <button
                        onClick={handleSubmit}
                        disabled={isLoading}
                        className='px-6 py-2 text-sm font-medium text-white bg-primary-main rounded-md hover:bg-primary-dark disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-primary-main focus:ring-offset-2'
                        aria-label={isLoading ? (isEditMode ? t`Updating...` : t`Saving...`) : isEditMode ? t`Update` : t`Save`}
                    >
                        {isLoading ? (isEditMode ? t`Updating...` : t`Saving...`) : isEditMode ? t`Update` : t`Save`}
                    </button>
                </div>
            </div>
        </div>
    )
}
